import { FunctionComponent, SVGProps } from 'react';

/**
 * Marks an SVG as one of ours rather than Astryx's. Styling hook only — it is
 * what the global rule in `global.styles.tsx` targets to undo Astryx's
 * `svg { display: block }` reset for legacy icons. Not a test selector.
 */
export const LEGACY_ICON_CLASS = 'inq-icon';

export type IconProps = {
  width?: number;
  height?: number;
  rotate?: number;
  className?: string;
};

const Icon = ({
  Svg,
  width,
  height,
  rotate,
  className,
  ...props
}: IconProps & {
  Svg: FunctionComponent<SVGProps<SVGSVGElement>>;
}) => {
  return (
    <Svg
      // Merged rather than overwritten: styled(SomeIcon) reaches the SVG by
      // passing its generated class down through here.
      className={
        className ? `${LEGACY_ICON_CLASS} ${className}` : LEGACY_ICON_CLASS
      }
      data-selector="icon-svg"
      focusable={false}
      width={width || 16}
      height={height || 16}
      style={
        rotate
          ? {
              transform: `rotate(${rotate}deg)`,
            }
          : {}
      }
      {...props}
    />
  );
};

export default Icon;
